import { useUi } from '../../store/ui';
import styles from './Toast.module.css';

export function Toast() {
  const toast = useUi((s) => s.toast);
  const hide = useUi((s) => s.hideToast);
  if (!toast) return null;
  return (
    <div className={styles.toast} role="status">
      <span className={styles.message}>{toast.message}</span>
      {toast.actions.map((a) => (
        <button
          key={a.label}
          type="button"
          className={styles.action}
          onClick={() => {
            a.run();
            hide(toast.id);
          }}
        >
          {a.label}
        </button>
      ))}
    </div>
  );
}
